import {
	CatalogType,
	CLIENT_VISIT_STATUS_LABELS,
	CLIENT_VISIT_STATUSES,
} from '@supply-mover-2-0/shared';
import { createStatusFilter } from './factories';
import type { FilterConfig } from './types';

/**
 * PD-16801 — a visit-list value filter (visit type or outcome) whose options
 * are the tenant's catalog values. Visits store the value NAME, so the name is
 * both the option id and its label.
 */
const visitCatalogFilter = (config: {
	label: string;
	placeholder: string;
	catalogType: CatalogType;
	fieldName: string;
	queryParamName: string;
}): FilterConfig => ({
	type: 'multi-select',
	label: config.label,
	placeholder: config.placeholder,
	colorScheme: 'purple',
	searchable: true,
	loadOnFocus: true,
	displayFields: {
		id: 'name' as keyof unknown,
		primary: 'name' as keyof unknown,
	},
	apiEndpoint: '/catalog-values',
	apiParams: { catalogType: config.catalogType },
	queryParamName: config.queryParamName,
	multiple: true,
	queryMapping: {
		objectTable: 'client_visit',
		fieldName: config.fieldName,
		joinType: 'direct',
	},
	format: 'array',
	valueExtractor: {
		property: 'id',
	},
	listKeys: ['reports'],
});

/** PD-16801 — filters for the Visit Log report. */
export const clientVisitFilters: Record<string, FilterConfig> = {
	visitStatuses: {
		...createStatusFilter({
			label: 'Visit Status',
			options: CLIENT_VISIT_STATUSES.map((status) => ({
				id: status,
				label: CLIENT_VISIT_STATUS_LABELS[status],
			})),
			objectTable: 'client_visit',
			fieldName: 'status',
			listKeys: ['reports'],
			colorScheme: 'green',
		}),
		queryParamName: 'visitStatuses',
	},

	visitTypes: visitCatalogFilter({
		label: 'Visit Type',
		placeholder: 'Select visit types...',
		catalogType: CatalogType.ClientVisitType,
		fieldName: 'visitType',
		queryParamName: 'visitTypes',
	}),

	visitOutcomes: visitCatalogFilter({
		label: 'Visit Outcome',
		placeholder: 'Select visit outcomes...',
		catalogType: CatalogType.ClientVisitOutcome,
		fieldName: 'outcome',
		queryParamName: 'visitOutcomes',
	}),
};
